export const soloProjects = [
  {
    id: 1,
    title: 'BuzzAgentsAI',
    description:
      'AI agents automation platform enabling businesses to deploy intelligent agents for workflow automation, content generation, and customer engagement.',
    technologies: ['Next.js', 'Node.js', 'TypeScript', 'AI Agents'],
    link: '',
    github: 'https://github.com/RajanPandey1311',
    featured: true,
  },
  {
    id: 2,
    title: 'MovieReel',
    description:
      'AI-powered movie discovery platform with personalized recommendations, advanced search, and curated watchlists using ML algorithms.',
    technologies: ['React', 'Node.js', 'AI/ML', 'MongoDB'],
    link: '',
    github: 'https://github.com/RajanPandey1311',
    featured: true,
  },
  {
    id: 3,
    title: 'LMS Platform — Cleveratti',
    description:
      'Full-featured e-learning platform with role-based access control, course management, progress tracking, and AI-powered features.',
    technologies: ['React', 'Node.js', 'MongoDB', 'RBAC'],
    link: '',
    github: '',
    featured: false,
  },
  {
    id: 4,
    title: 'TrueLoop FeedApp',
    description:
      'Anonymous feedback platform with Gemini AI-powered message suggestions, secure authentication, and real-time notifications.',
    technologies: ['Next.js 14', 'NextAuth', 'MongoDB', 'Gemini AI'],
    link: 'https://trueloop.vercel.app/',
    github: 'https://github.com/RajanPandey1311/Trueloop',
    featured: false,
  },
  {
    id: 5,
    title: 'MERN E-commerce',
    description:
      'Full-stack e-commerce application with JWT authentication, admin panel, product management, cart system, and payment integration.',
    technologies: ['React', 'Node.js', 'Express', 'MongoDB', 'JWT'],
    link: 'https://rajan-ecommerce.vercel.app/',
    github: 'https://github.com/RajanPandey1311/MERN_Ecommerce',
    featured: false,
  },
  {
    id: 6,
    title: 'Canvas Editor',
    description:
      'Interactive canvas editor with Fabric.js for image manipulation, background customization via Unsplash API, and export capabilities.',
    technologies: ['React', 'Fabric.js', 'Unsplash API'],
    link: 'https://canvas-editor-fabric-js.vercel.app/',
    github: 'https://github.com/RajanPandey1311/Canvas_editor_Fabric.js',
    featured: false,
  },
  {
    id: 7,
    title: 'MERN Quiz App',
    description:
      'Sophisticated quiz application with timed challenges, leaderboards, and Redux state management for seamless user experience.',
    technologies: ['React', 'Redux', 'Node.js', 'MongoDB'],
    link: 'https://brain-teaser-ten.vercel.app/',
    github: 'https://github.com/RajanPandey1311/Brain-Teaser',
    featured: false,
  },
  {
    id: 8,
    title: 'ClimaCheck Weather App',
    description:
      'Real-time weather application with geolocation support, 5-day forecasts, and interactive weather maps using OpenWeather API.',
    technologies: ['React', 'API', 'GeoLocation'],
    link: 'https://climacheckk.netlify.app/',
    github: 'https://github.com/RajanPandey1311/ClimaCheck',
    featured: false,
  },
  {
    id: 9,
    title: 'FitFlare Gym App',
    description:
      'Animated fitness web application with smooth Framer Motion transitions, workout plans, and EmailJS contact integration.',
    technologies: ['React', 'Framer Motion', 'EmailJS'],
    link: 'https://fit-flare.vercel.app/',
    github: 'https://github.com/RajanPandey1311/FitFlare',
    featured: false,
  },
];
